import React from "react";
import { TextField, TextFieldProps, Box, Typography } from "@mui/material";
import * as SC from "./enhanced-form-field.style";

export interface EnhancedFormFieldProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'outlined' | 'filled' | 'standard';
  helperText?: string;
  error?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  mobileOptimized?: boolean;
}

export const EnhancedFormField = ({
  label,
  helperText,
  error,
  required,
  fullWidth = true,
  mobileOptimized = true,
  className,
  ...props
}: EnhancedFormFieldProps) => {
  return (
    <SC.EnhancedFormField mobileOptimized={mobileOptimized}>
      <TextField
        {...props}
        label={label}
        variant="outlined"
        fullWidth={fullWidth}
        error={error}
        required={required}
        className={`enhanced-field ${className || ""}`}
        helperText={helperText}
        InputProps={{
          ...props.InputProps,
          sx: {
            fontSize: mobileOptimized ? { xs: '1rem', sm: '0.95rem' } : '0.95rem',
            ...props.InputProps?.sx,
          },
        }}
        InputLabelProps={{
          ...props.InputLabelProps,
          sx: {
            fontSize: mobileOptimized ? { xs: '0.9rem', sm: '0.85rem' } : '0.85rem',
            fontWeight: 500,
            ...props.InputLabelProps?.sx,
          },
        }}
        FormHelperTextProps={{
          ...props.FormHelperTextProps,
          sx: {
            fontSize: mobileOptimized ? { xs: '0.8rem', sm: '0.75rem' } : '0.75rem',
            marginRight: 0,
            marginLeft: 0,
            ...props.FormHelperTextProps?.sx,
          },
        }}
      />
    </SC.EnhancedFormField>
  );
};
